import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const deleteSellerApi = (id) =>
    Promise.resolve(axios.delete(endpoints.deleteSeller.replace("{id}", id)));
